import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { MdDelete } from "react-icons/md";
import { Link } from 'react-router-dom';
import { FaGear } from 'react-icons/fa6';
import AsignarUsuario from './AsignarUsuario';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'20%'}}>Area N1</th>
        <th className='d-none d-sm-table-cell' style={{width:'40%'}}>Descripción área N1</th>
        <th className='d-none d-sm-table-cell' style={{width:'2%'}}>Quitar</th>
        <th className='d-none d-sm-table-cell' style={{width:'2%'}}>Config</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Juez</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  
  if (props.listOfAreasN1) {
    
    const rows = props.listOfAreasN1.map((row, index) => { 

      return (      
        <tr key={index}>        
          <td>  
            {row["arean1"].nombrearea}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row["arean1"].descripcionarea}
          </td>  
          <td>
            <Button variant="secondary"><MdDelete /></Button>  
          </td> 
          <td>
            <Button variant="secondary">
              {/*row.childid is the arean1id and row.id is the id organigramaarea*/}
              <Link
                to={`/editorganigramaareasn2/${row.childid}/${row.id}`}
                  //search: "?sort=name",
                  //hash: "#the-hash",
                  
                  state= {{
                    organigrama: props.organigrama
                  }}
                
              ><FaGear size={15} color='white'/>
              </Link>              
            </Button>          
          </td>  
          <td>
            {/*{row.user?row.user.primerapellido + ", " + row.user.primernombre:null}  */}

            <AsignarUsuario 
              id={row.id} 
              organigramaareasid={row.id} 
              area={row.arean1}
              user={row.user}
            />              
          </td>  
          
            
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}
const CompetenciaAreasN1List = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody 
              mode={props.mode} 
              onSelected={props.onSelected} 
              listOfAreasN1={props.listOfAreasN1} 
              organigrama={props.organigrama} 
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default CompetenciaAreasN1List;